import drfProvider from './dataProvider';
import {fetchUtils } from 'react-admin';
import * as Constants from '../constants'

const convertFileToBase64 = file => new Promise((resolve, reject) => {
    const reader = new FileReader();
    let rawFile;
    if(file.rawFile) {
        rawFile = file.rawFile
        reader.readAsDataURL(rawFile);

        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
    }
    else {
        convertUrlToBlob(file).then(
            (blob) => { 
                rawFile = blob
                reader.readAsDataURL(rawFile);

                reader.onload = () => resolve(reader.result);
                reader.onerror = reject;
            })
    }   
});

const convertUrlToBlob = url => {
   return fetch(url, {
    method: 'GET',
    mode: 'cors',
    cache: 'no-cache',
    headers: {
        Origin: window.location.origin,
    },
})
    .then(res => res.blob())
}

const httpClient = (url, options = {}) => {
    if (!options.headers) {
        options.headers = new Headers({ Accept: 'application/json' });
    }
    const token = localStorage.getItem('token');
    if(token) {
      options.headers.set('Authorization', `Bearer ${token}`);
    }
    return fetchUtils.fetchJson(url, options);
  }
  
const dataProvider = drfProvider(Constants.siteUrl, httpClient);

const uploadFileDataProvider = {
    ...dataProvider,
    custom: (resource, actionOrParams, maybeParams = {}) => {
        try {
            const usesObjectSignature = typeof actionOrParams === 'object' && actionOrParams !== null;
            const action = usesObjectSignature ? actionOrParams.action : actionOrParams;
            const params = usesObjectSignature ? actionOrParams : maybeParams;

            if (!resource || !action) {
                return Promise.reject(new Error('custom dataProvider requires resource and action'));
            }
            if (params.id === undefined || params.id === null) {
                return Promise.reject(new Error('custom dataProvider requires params.id'));
            }

            const url = `${Constants.siteUrl}/${resource}/${params.id}/${action}/`;
            return httpClient(url, {
                method: 'POST',
                body: JSON.stringify(params.data || {}),
            }).then(({ json }) => ({ data: json }));
        } catch (error) {
            return Promise.reject(error);
        }
    },
    create: (resource, params) => {
        if (resource == 'stations'){
            let promises = [];

            if (params.data?.riddle?.image) {
                promises.push(convertFileToBase64(params.data.riddle.image));
            }
            else {
                promises.push(new Promise((resolve, reject)=> {resolve(null)}));
            }
            if (params.data?.riddle?.video) {
                promises.push(convertFileToBase64(params.data.riddle.video));
            }
            else {
                promises.push(new Promise((resolve, reject)=> {resolve(null)}));
            }
            return Promise.all(promises).then(([image, video]) => {
                const riddle = image || video ? {
                    ...params.data.riddle,
                    image: image || '',
                    video: video || ''
                } : params.data.riddle;

                return dataProvider.create(resource, {
                    ...params,
                    data: {
                        ...params.data,
                        riddle
                    },
                });
            });
        }
        else if (resource !== 'overlays') {
            // fallback to the default implementation
            return dataProvider.create(resource, params);
        }
        /**
         * For posts update only, convert uploaded image in base 64 and attach it to
         * the `picture` sent property, with `src` and `title` attributes.
         */
        
        // Freshly dropped pictures are File objects and must be converted to base64 strings
        else if (params.data.image) {
            const newPicture = params.data.image
            console.log(newPicture)
            if(newPicture.rawFile) {
                return convertFileToBase64(newPicture)
                    .then(base64Picture => {
                        return dataProvider.create(resource, {
                        ...params,
                        data: {
                            ...params.data,
                            image: base64Picture
                        },
                    })});
                }
            else {
                delete params.data.image
                return dataProvider.create(resource, {
                    ...params,
                    data: {
                        ...params.data
                    },
                }) 
            }
        }
    },
    update: (resource, params) => {
        if (resource == 'stations'){
            let promises = [];

            if (params.data?.riddle?.image) {
                promises.push(convertFileToBase64(params.data.riddle.image));
            } else {
                promises.push(new Promise((resolve, reject) => {
                    resolve(null);
                }));
            }
            if (params.data?.riddle?.video) {
                promises.push(convertFileToBase64(params.data.riddle.video));
            }  else {
                promises.push(new Promise((resolve, reject) => {
                    resolve(null);
                }));
            }
            return Promise.all(promises).then(([image, video]) => {
                const riddle = image || video ? {
                    ...params.data.riddle,
                    image: image || '',
                    video: video || ''
                } : params.data.riddle;

                return dataProvider.update(resource, {
                    ...params,
                    data: {
                        ...params.data,
                        riddle,
                    },
                });
            });
        }
        else if (resource !== 'overlays') {
            
            // fallback to the default implementation
            return dataProvider.update(resource, params);
        }
        /**
         * For posts update only, convert uploaded image in base 64 and attach it to
         * the `picture` sent property, with `src` and `title` attributes.
         */
        
        // Freshly dropped pictures are File objects and must be converted to base64 strings
        else if (params.data.image) {
            const newPicture = params.data.image
            console.log(newPicture)
            if(newPicture.rawFile) {
                return convertFileToBase64(newPicture)
                    .then(base64Picture => {
                        return dataProvider.update(resource, {
                        ...params,
                        data: {
                            ...params.data,
                            image: base64Picture
                        },
                    })});
                }
            else {
                delete params.data.image
                return dataProvider.update(resource, {
                    ...params,
                    data: {
                        ...params.data
                    },
                }) 
            }
        }
    }
};

export default uploadFileDataProvider;